import { render, staticRenderFns } from "./FileBox.vue?vue&type=template&id=80d474c0&scoped=true&"
import script from "./FileBox.vue?vue&type=script&lang=js&"
export * from "./FileBox.vue?vue&type=script&lang=js&"
import style0 from "./FileBox.vue?vue&type=style&index=0&id=80d474c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d474c0",
  null
  
)

export default component.exports